import validate from "validate.js";
import { CPF, CNPJ } from "cpf_cnpj";
import Barcoder from "barcoder";
import Moment from "moment";

validate.validators.presence.message = "Este campo não pode estar em branco.";
validate.validators.email.message = "E-mail deve possuir um formato válido.";
validate.validators.equality.message = "As senhas devem ser iguais.";

validate.validators.barCode = (value, { allowEmpty, message }) =>
  allowEmpty || Barcoder.validate(value) ? null : message || "é inválido";
validate.validators.cpf = (value, { allowEmpty, message }) =>
  allowEmpty || CPF.isValid(value) ? null : message || "é inválido";
validate.validators.cnpj = (value, { allowEmpty, message }) =>
  allowEmpty || CNPJ.isValid(value) ? null : message || "é inválido";
validate.validators.simpleDate = (value, { allowEmpty, message }) =>
  (allowEmpty && (!value || value.length === 0)) ||
  new Moment(value, "DD/MM/YYYY").isValid()
    ? null
    : message || "é inválida";
validate.validators.dateIsBefore = (
  value,
  { message, attribute },
  key,
  attributes
) => {
  const compare = new Moment(attributes[attribute], "DD/MM/YYYY").format(
    "YYYY-MM-DD"
  );
  const currentValue = new Moment(value, "DD/MM/YYYY").format("YYYY-MM-DD");

  return new Moment(currentValue).isBefore(compare)
    ? null
    : message || "é inválida";
};
validate.validators.dateIsAfter = (
  value,
  { message, attribute },
  key,
  attributes
) => {
  const compare = new Moment(attributes[attribute], "DD/MM/YYYY").format(
    "YYYY-MM-DD"
  );
  const currentValue = new Moment(value, "DD/MM/YYYY").format("YYYY-MM-DD");

  return new Moment(currentValue).isAfter(compare)
    ? null
    : message || "é inválida";
};
validate.validators.differentFromToday = (value, { message }) => {
  const today = new Moment().format("YYYY-MM-DD");
  const currentValue = new Moment(value, "DD/MM/YYYY").format("YYYY-MM-DD");

  return new Moment(currentValue).isSameOrAfter(today)
    ? null
    : message || "é inválida";
};

export default validate;



// WEBPACK FOOTER //
// ./src/util/validate.js